import React from "react";
import { AlertTriangle, RotateCw } from "lucide-react";

// Red de seguridad global: si algo crashea en cualquier parte del árbol de
// React (ej. un bug puntual de un componente), mostramos una pantalla
// amigable con botón de recarga en vez de dejar la pantalla blanca muda.
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("Error de la aplicación (capturado por ErrorBoundary):", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          data-testid="app-error-boundary"
          className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background px-6 text-center"
        >
          <div className="h-14 w-14 rounded-full bg-destructive/10 text-destructive grid place-items-center">
            <AlertTriangle size={26} />
          </div>
          <div>
            <h1 className="font-heading text-xl font-semibold">Algo salió mal</h1>
            <p className="text-sm text-muted-foreground mt-1 max-w-sm">
              Tuvimos un problema inesperado mostrando esta pantalla. Tus datos están seguros y guardados localmente.
            </p>
          </div>
          <button
            data-testid="app-error-boundary-reload"
            onClick={() => window.location.reload()}
            className="h-11 px-5 rounded-[var(--radius)] bg-primary text-primary-foreground font-heading font-semibold text-sm flex items-center gap-2"
          >
            <RotateCw size={15} /> Recargar
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
